import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Wrapper } from '../../styles/SearchBooksStyle';
import { getListOfBooksByAgeGroup, searchBooksByQuery } from '../../../controller/bookSelection/bookSelectionController';

const SearchOwnBooks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // React Router v6 hook to read query params
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category') || '';
  const OS = searchParams.get("OS") || "";
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOpen, setSortOpen] = useState(false);
  const [sortBy, setSortBy] = useState('popular');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  

  const { bookList, totalBook, next, previous, isLoading, error } = useSelector(
    (state) => state.bookSelection
  );

  // Load books on mount or when category/sort/page changes
  useEffect(() => {
    if (!searchQuery.trim()) {
      dispatch(getListOfBooksByAgeGroup({
        ageGroup: category,
        sortBy,
        page,
        pageSize: rowsPerPage
      }));
    }
  }, [dispatch, category, sortBy, searchQuery, page, rowsPerPage]);

  const performSearch = () => {
    if (searchQuery.trim()) {
      dispatch(searchBooksByQuery({
        query: searchQuery,
        page,
        pageSize: rowsPerPage
      }));
    }
  };

  const handlePrev = () => {
    if (previous) setPage((p) => p - 1);
  };

  const handleNext = () => {
    if (next) setPage((p) => p + 1);
  };

    const handleBookSelected = (bookId) => {
        navigate(`/books/preview-own/${bookId}`, {
            state: {
            OS
    }
  });
};

  return (
    <Wrapper>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search for books..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') performSearch();
          }}
        />
        {searchQuery && (
          <button onClick={() => setSearchQuery('')}>✕</button>
        )}
        <button onClick={performSearch}>🔍</button>
      </div>

      <div className="sort-button-wrapper">
        <button onClick={() => setSortOpen((o) => !o)}>Sort</button>
        {sortOpen && (
          <>
            <div className="overlay" onClick={() => setSortOpen(false)} />
            <div className="sort-popup">
              <div className="sort-header">
                <span>Sort By</span>
                <button onClick={() => setSortOpen(false)}>✕</button>
              </div>
              {['popular', 'fiction', 'history', 'horror'].map((opt) => (
                <button
                  key={opt}
                  onClick={() => {
                    setSortBy(opt);
                    setSortOpen(false);
                  }}
                >
                  {opt.charAt(0).toUpperCase() + opt.slice(1)}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      {isLoading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}

      <div className="book-grid">
        {!isLoading &&
          bookList.map((book) => (
            <div
              className="book-card"
              key={book.id}
              onClick={() => handleBookSelected(book.id)}
            >
              <div className="cover">
                {book.formats['image/jpeg'] ? (
                  <img
                    src={book.formats['image/jpeg']}
                    alt={book.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <span>No Image</span>
                )}
              </div>
              <div className="meta">
                <p className="title">{book.title}</p>
                <p className="author">
                  <strong className="book-desc-label">Author</strong>: {book.authors[0]?.name || 'Unknown'}
                </p>
                <p className="copyright">
                  Copyright: {book.copyright ? 'Yes' : 'No'}
                </p>
              </div>
            </div>
          ))}
      </div>

      <div className="pagination">
        <label>
          Rows per page:
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(1);
            }}
          >
            {[50, 100, 150].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>

        <span>
          Page {page} • {totalBook} total
        </span>

        <button onClick={handlePrev} disabled={!previous}>
          {'<'} Prev
        </button>
        <button onClick={handleNext} disabled={!next}>
          Next {'>'}
        </button>
      </div>
    </Wrapper>
  );
};

export default SearchOwnBooks;